import '../styles/Home.css';
import logo_load from '../assets/load.gif';
import logo_kdo from '../assets/logo-kdo.png';
import Partage from '../components/Partage';
import ListObject from '../components/ListObject';
import Banner from '../components/Banner';
import Footer from '../components/Footer';
import Accueil from '../components/Accueil';
import AuthServices from '../services/AuthServices';
import listServices from "../services/listServices";
import sharedListServices from "../services/sharedListServices";
import { useState, useEffect } from 'react'
import Sidebar from '../components/Sidebar';
// import Api from '../services/Api';

function Home({ p_user, p_key, p_setkey, p_isProprio, p_readonlyKey, p_roles, p_url = null, p_isReadOnlyView = false, p_sharedListId = null, p_sharedOwnerName = null }) {

  const [tabObject, settabObject] = useState([]);
  const [isDataLoading, setDataLoading] = useState(false)
  const [isDejaCharge, setIsDejaCharge] = useState(false)
  const [isError, setError] = useState(false)
  const [showSidebar, setShowSidebar] = useState(false);
  const [collapseControl, setCollapseControl] = useState(null);
  const [sharedLists, setSharedLists] = useState([]);

  // const [user, setUser] = useState("")
  const [listNames, setListNames] = useState({});

  const v_readOnlyLink = window.location.origin + '?key=' + p_readonlyKey;
  const isEditable = p_isProprio && !p_isReadOnlyView;
  const ownerKeyFromStorage = AuthServices.getConnectedKey();

  useEffect(() => {
    setShowSidebar(false);
  }, [p_user, p_key]);

  useEffect(() => {
    if (!ownerKeyFromStorage) {
      setSharedLists([]);
      return;
    }
    setSharedLists(sharedListServices.getAllForOwner(ownerKeyFromStorage));
  }, [ownerKeyFromStorage]);

  console.log("Home p_roles : " + p_roles);

  async function fetchListNames() {
    const v_allName = await listServices.getAllListByKey(p_key);
    console.log(v_allName);
    const namesMap = {};
    for (const v_listInfos of v_allName) {
      namesMap[v_listInfos.id] = v_listInfos.name; // Si aucun nom, affiche "Liste X"
      console.log(v_listInfos);
    }
    setListNames(namesMap);
    console.log("fetchListNames", listNames);
  }

  useEffect(() => {
    if (tabObject.length === 0 && p_key && !isDataLoading && !isDejaCharge) {
      console.log("Initialisation chargement");
      fetchListNames();
      getListeObjectByUser(p_key);
    }
  }, [p_key, isDejaCharge]);

  function refreshListe() {
    fetchListNames();
    settabObject([]);
    setIsDejaCharge(false);
    getListeObjectByUser(p_key);
    console.log("refreshListe user : " + p_user);
  }

  async function addListe() {
    const v_newName = prompt("Nom de la nouvelle liste", "");
    if (v_newName) {
      await listServices.createRefList(p_key, v_newName);
      fetchListNames();
    }
  }

  async function getListeObjectByUser(p_key) {
    // console.log("getListeObjectByUser debut: "+pp_user);

    console.log("p_key: " + p_key)
    if (!p_key) {
      setError(true)
      setIsDejaCharge(true);
      console.log("p_key: " + p_key)
    }
    else {

      const requestOptions = {
        method: "GET",
        mode: 'cors',
        headers: { "Content-Type": "application/json" }
      };

      if (tabObject.length === 0 && !isDataLoading && !isDejaCharge) {
        setDataLoading(true)
        try {
          //const response = await fetch("https://hook.eu2.make.com/2v5lf79iwtckvc85j4zdcm64ov52sngm?api=getbyuser", requestOptions)
          const timestamp = Date.now(); //To avoid cache data
          const response = await fetch("https://app.listaki.fr/api/WS/getListObjectByKey.php?key=" + p_key + "&r=" + timestamp, requestOptions)
          if (response.ok) {
            const tabObjectresp = await response.json()
            settabObject(tabObjectresp);
            setError(false);
          } else {
            console.log("Erreur lors de l'appel à l'API");
            setError(true);
            setIsDejaCharge(true);
          }
          // console.log("Reponse api debut");
          // console.log(tabObject)
          // console.log("Reponse api fin");
          setIsDejaCharge(true);
        } catch (err) {
          console.log(err)
          setError(true)
          setIsDejaCharge(true);
        } finally {
          setDataLoading(false)
        }
      }
      else {
        console.log("tabObject deja chargé")
        console.log(tabObject)
      }
    }
  };

  function deconnexion() {
    AuthServices.logout(p_setkey); //Si pas de user pour la key ont la supprime
    refreshListe();
  }

  const sharedListId = p_sharedListId || null;
  const sharedListKey = sharedListId || "all";
  const sharedOwnerLabel = p_sharedOwnerName ? `Listes de ${p_sharedOwnerName}` : "Listes partagees";
  const sharedListName = sharedListId ? (listNames?.[sharedListId] || "Liste partagee") : sharedOwnerLabel;
  const isSharedListSaved = sharedListServices.isSaved(ownerKeyFromStorage, p_key, sharedListKey);
  const canMemorizeSharedList = Boolean(p_isReadOnlyView && ownerKeyFromStorage);
  console.log("ownerKeyFromStorage:", ownerKeyFromStorage);
  const handleSaveSharedList = () => {
    if (!ownerKeyFromStorage || !p_key) return;
    sharedListServices.add({
      ownerKey: ownerKeyFromStorage,
      ownerName: p_sharedOwnerName || "",
      key: p_key,
      idList: sharedListKey,
      name: sharedListName,
      url: sharedListServices.buildUrl(p_key, sharedListKey)
    });
    setSharedLists(sharedListServices.getAllForOwner(ownerKeyFromStorage));
  };

  const handleRemoveSharedList = (entry) => {
    if (!entry) return;
    sharedListServices.remove(ownerKeyFromStorage, entry.key, entry.idList);
    setSharedLists(sharedListServices.getAllForOwner(ownerKeyFromStorage));
  };

  const handleOpenSharedList = (entry) => {
    if (!entry?.key) return;
    const targetUrl = entry.url || sharedListServices.buildUrl(entry.key, entry.idList);
    window.location.assign(targetUrl);
  };

  // Composant icône hamburger
  const HamburgerIcon = () => (
    <div className="kdo-hamburger-icon" onClick={() => {if (window.umami) window.umami.track('ShowSideBar'); setShowSidebar(true);}}>
      <span></span>
      <span></span>
      <span></span>
    </div>
  );

  return !p_user ? (
    <div className="kdo-home">
      <Banner>
         <a href="https://listaki.fr"><img src={logo_kdo} alt='Mes Listes' className='kdo-ban-logo' /></a>
        <h1 className='kdo-ban-title'>LISTAKI : Crée ta liste !</h1>
      </Banner>
      <Accueil />
      <Footer />
    </div>
  ) : (
    <div className="kdo-home">

      {showSidebar && (
         <Sidebar
          p_roles = {p_roles}
          onClose={() => setShowSidebar(false)}
          onLogout={deconnexion}
          p_sharedLists={sharedLists}
          p_isProprio={Boolean(ownerKeyFromStorage)}
          onOpenSharedList={handleOpenSharedList}
          onRemoveSharedList={handleRemoveSharedList}
        />
      )}

      <Banner>
        <a href="https://listaki.fr"><img src={logo_kdo} alt='Mes Listes' className='kdo-ban-logo' /></a>
        <div className='kdo-ban-title'>
          <h3>LISTAKI de {p_user}</h3>
        </div>
        <HamburgerIcon />
      </Banner>
        {isEditable ? (
          <span>
            <Partage p_link={v_readOnlyLink} />
            &nbsp;
            <button className="kdo-home-button" onClick={() => {if (window.umami) window.umami.track('add-Liste'); addListe();}}>Créer une liste</button>
          </span>
        ) : (
          <a href="/" alt="Accueil" className="kdo-home-button">
            {p_isReadOnlyView && ownerKeyFromStorage ? "Retour chez moi" : "M'inscrire"}
          </a>
        )}
        {canMemorizeSharedList && (
          <>
            &nbsp;
            <button className="kdo-home-button" onClick={handleSaveSharedList} disabled={isSharedListSaved}>
              {isSharedListSaved ? "Liste memorisee" : "Memoriser cette liste"}
            </button>
          </>
        )}
        &nbsp;<button className="kdo-home-button" onClick={refreshListe}>Actualiser</button>
        &nbsp;{collapseControl?.hasLists && (
          <button
            type="button"
            className="kdo-home-button kdo-home-button--icon"
            onClick={() => collapseControl?.toggle?.()}
            aria-label={collapseControl?.isCollapsed ? "Agrandir toutes les listes" : "Réduire toutes les listes"}
            title={collapseControl?.isCollapsed ? "Agrandir toutes les listes" : "Réduire toutes les listes"}
          >
            <span aria-hidden="true">{collapseControl?.isCollapsed ? "⤢" : "⤡"}</span>
          </button>
        )}
      <div className="kdo-home-listobject">
        {tabObject.length === 0 && isDataLoading ? (
          <div>
            <p><img src={logo_load} alt='Chargement' /></p>
            <p>Chargement...</p>
          </div>
        ) : isError ? (
          <p>Il y a eu une erreur, veuillez patienter quelques instants et recharger!</p>
        ) : (
          <ListObject p_key={p_key} p_tabObject={tabObject}
            p_setTabOject={settabObject}
            p_isProprio={isEditable}
            p_readonlyKey={p_readonlyKey}
            p_user={p_user}
            p_listNames={listNames}
            p_setListNames={setListNames}
            p_url={p_url}
            p_onGlobalCollapseChange={setCollapseControl} />
        )
        }
      </div>
      <Footer />
    </div>
  )

};

export default Home;
